import {
  BulkLoadedType,
  BulkRemoveType,
  ErrorType,
  InvalidateType,
  LoadedMoreType,
  LoadedType,
  type QueryParams,
  RequestMoreType,
  RequestType,
} from 'common/actions/insightQueries';

import queryReducerFactory, { type QueriesState, type QueryState } from './queryReducerFactory';
export { defaultState } from './queryReducerFactory';

import type { Insight } from 'common/api/endpoints/insight';

export type InsightQueriesState = QueriesState<Insight, QueryParams>;
export type InsightQueryState = QueryState<Insight, QueryParams>;

export default queryReducerFactory<Insight, QueryParams>({
  bulkLoadedType: BulkLoadedType,
  bulkRemoveType: BulkRemoveType,
  errorType: ErrorType,
  invalidateType: InvalidateType,
  loadedMoreType: LoadedMoreType,
  loadedType: LoadedType,
  requestMoreType: RequestMoreType,
  requestType: RequestType,
});
